import { render } from "./Kform.vue?vue&type=template&id=399a0810&scoped=true"
import script from "./Kform.vue?vue&type=script&lang=js"
export * from "./Kform.vue?vue&type=script&lang=js"

import "./Kform.vue?vue&type=style&index=0&id=399a0810&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399a0810"]])

export default __exports__